import { render, staticRenderFns } from "./TableMobileTransationComponent.vue?vue&type=template&id=797d021e&"
import script from "./TableMobileTransationComponent.vue?vue&type=script&lang=js&"
export * from "./TableMobileTransationComponent.vue?vue&type=script&lang=js&"
import style0 from "./TableMobileTransationComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VContainer,VDivider,VProgressLinear})
